import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;

	@media (max-width: 1000px) {
		padding-top: 1rem;
	}
`;

export const centralize = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${color.interface.white};
	border-radius: 5px;
	padding: 1rem;
`;
